import { LOCAL_STORAGE_AUTH_KEY } from '@/common/auth';
import { CapacitorNotificationsManager } from '@/pages/alerts/notifications-manager/capacitor-notifications-manager';
import { Capacitor } from '@capacitor/core';
import { ReactNode, useEffect, useState } from 'react';

// This component is used to ensure that any token we have saved in Capacitor preferences is loaded into local storage
// before the app is allowed to render.
export const LoadCapacitorInitialState = ({ children }: { children: ReactNode }) => {
	const [loadedToken, setLoadedToken] = useState<boolean>(false);

	useEffect(() => {
		(async () => {
			if (Capacitor.isNativePlatform()) {
				const { Preferences } = await import('@capacitor/preferences');
				const { value } = await Preferences.get({ key: LOCAL_STORAGE_AUTH_KEY });
				if (value) {
					// eslint-disable-next-line no-console
					console.log('Setting token from Capacitor preferences.');
					localStorage.setItem(LOCAL_STORAGE_AUTH_KEY, value);
				}

				// Reschedule notifications on app launch to ensure they keep going
				const manager = new CapacitorNotificationsManager();
				await manager.ensureNotificationsScheduled();

				// Hide the splash screen too.
				const { SplashScreen } = await import('@capacitor/splash-screen');
				setTimeout(() => SplashScreen.hide(), 200);
			}
			setLoadedToken(true);
		})();
	}, []);

	if (!loadedToken) return <p>Loading...</p>;

	return <>{children}</>;
};
